import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div<{ $autoTailorJob?: boolean }>`
  height: 100%;
  height: 100%;
  width: 100%;

  padding-top: ${({ $autoTailorJob }) => ($autoTailorJob ? '0' : '52px')};

  ${({ $autoTailorJob }) => {
    return `
      ${Media.Phone`
        padding-top: ${$autoTailorJob ? '0' : '62px'};
      `};

      ${Media.Tablet`
        padding: ${$autoTailorJob ? '0' : '52px 0 32px'};
      `}
    `
  }}
`

export const ContentSectionWrapper = styled.div<{ $autoTailorJob?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 36px;
  background-color: ${Colors.White};
  transition: all 200ms ease-in;
  padding-bottom: 84px;
  min-height: 100%;
  border-radius: ${({ $autoTailorJob }) => ($autoTailorJob ? '0 0 0 0' : '12px 12px 0 0')};

  ${Media.Phone`
    padding: 0 0 102px;
  `};
`
